import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Button from '../common/Button';
import ClientSideAgGrid from '../common/customAgGrid/ClientSideAgGrid';
import Modal from '../common/Modal';

const ImportValidationModal = ({
  open,
  onClose,
  onImportValidEntries,
  onCheckIssues,
  summary,
}: {
  open: boolean;
  onClose: () => void;
  onImportValidEntries: () => void;
  onCheckIssues: () => void;
  summary?: {
    totalRecords?: number;
    validRecords?: number;
    invalidRecords?: number;
  };
}) => {
  const { t } = useTranslation();
  const columns: ColDef[] = [
    {
      field: 'detectedEntries',
      headerName: t('priceList.detectedEntries'),
      width: 150,
      filter: false,
      sortable: false,
    },
    {
      field: 'validEntries',
      headerName: t('priceList.validEntries'),
      width: 150,
      filter: false,
      sortable: false,
    },
    {
      field: 'invalidEntries',
      headerName: t('priceList.invalidEntries'),
      width: 150,
      filter: false,
      sortable: false,
    },
  ];
  const rowData: any[] = [
    {
      detectedEntries: String(summary?.totalRecords ?? 0),
      validEntries: String(summary?.validRecords ?? 0),
      invalidEntries: String(summary?.invalidRecords ?? 0),
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('priceList.validationOfImportedPricelist')}
      size="md"
      isPriceListModal={true}
      footer={
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button variant="outlinedBlue" onClick={onImportValidEntries}>
            {t('priceList.importValidEntries')}
          </Button>
          <Button variant="outlinedBlue" onClick={onCheckIssues}>
            {t('priceList.checkIssues')}
          </Button>
        </Box>
      }
    >
      <Box sx={{ height: '400px' }}>
        <ClientSideAgGrid
          columnDefs={columns}
          rowData={rowData}
          loading={false}
          className="import-validation-grid"
          isInModal={true}
          infiniteRows={true}
        />
      </Box>
    </Modal>
  );
};

export default ImportValidationModal;
